// src/icons.ts
var phosphorIcons = [
  "archive-box",
  "arrow-bend-double-up-left",
  "arrow-bend-double-up-left-bold",
  "arrow-bend-double-up-right",
  "arrow-bend-double-up-right-bold",
  "arrow-bend-down-right-bold",
  "arrow-counter-clockwise-fill",
  "arrow-elbow-up-left-fill",
  "arrow-left-bold",
  "arrows-clockwise",
  "arrows-down-up-fill",
  "arrows-in-cardinal-bold",
  "arrow-square-out",
  "caret-right-bold",
  "check",
  "check-circle",
  "check-circle-bold",
  "checks-bold",
  "check-square-thin",
  "clock-counter-clockwise",
  "clock-counter-clockwise-bold",
  "clock-light",
  "cloud-check",
  "cloud-check-bold",
  "cloud-slash",
  "cloud-slash-bold",
  "cloud-warning",
  "cloud-warning-bold",
  "copy-light",
  "diamond-bold",
  "diamond-duotone",
  "diamond-fill",
  "diamonds-four-bold",
  "flag",
  "flag-checkered",
  "rocket-launch",
  "cake",
  "skull",
  "dot-bold",
  "microphone-bold",
  "stop-fill",
  "dot-duotone",
  "dots-three-circle",
  "download-fill",
  "download-simple-bold",
  "eraser-fill",
  "exclude-duotone",
  "eye",
  "eye-bold",
  "eye-slash",
  "floppy-disk",
  "gear",
  "gear-bold",
  "gear-thin",
  "house",
  "house-bold",
  "info",
  "info-bold",
  "link",
  "link-bold",
  "link-break-bold",
  "list-checks",
  "list-magnifying-glass",
  "list-plus",
  "lock-key-fill",
  "lock-key-open-fill",
  "lock-simple-open-light",
  "magnifying-glass",
  "magnifying-glass-bold",
  "pencil-line-duotone",
  "plus-bold",
  "plus-circle",
  "question",
  "seal-question-light",
  "share-network-bold",
  "shield-plus",
  "shield-warning",
  "shooting-star-fill",
  "split-horizontal",
  "square-thin",
  "subtitles-bold",
  "tabs",
  "tag",
  "text-b",
  "text-b-bold",
  "text-indent",
  "text-italic",
  "text-italic-bold",
  "text-outdent",
  "text-strikethrough-bold",
  "text-underline",
  "text-underline-bold",
  "trash-bold",
  "trash-duotone",
  "tree-structure-bold",
  "upload-simple-bold",
  "user-circle-gear",
  "warning-bold",
  "x",
  "x-bold",
  "x-circle"
];
var otherIcons = [
  "i-custom:ipld"
];
var numberToWord = {
  0: "zero",
  1: "one",
  2: "two",
  3: "three",
  4: "four",
  5: "five",
  6: "six",
  7: "seven",
  8: "eight",
  9: "nine"
};
var numberCircles = [];
Array.from({ length: 10 }).forEach((_v, indx) => {
  numberCircles.push(`ph:number-circle-${numberToWord[indx]}-fill`);
  numberCircles.push(`ph:number-circle-${numberToWord[indx]}`);
});
var allIcons = [
  ...phosphorIcons.map((iconName) => `i-ph:${iconName}`),
  ...numberCircles,
  ...otherIcons
];

export {
  phosphorIcons,
  otherIcons,
  numberCircles,
  allIcons
};
//# sourceMappingURL=chunk-KUOF7LLD.js.map